import { INotesSection } from '@modeso/types__aumico-lib-annualreport-be';

export interface INotesSectionViewModel extends INotesSection {
    isEditing?: boolean;
    filled?: boolean;
    isExpanded?: boolean;
    isCorrect?: boolean;
}
